import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';
import {IconColourEnum} from '../../../shared-icons/models/icons-colour.enum';

@Component({
  selector: 'app-cell-renderer-all-icons',
  templateUrl: './cell-renderer-all-icons.component.html',
  styleUrls: ['./cell-renderer-all-icons.component.scss'],
  standalone: false,
})
export class CellRendererAllIconsComponent implements ICellRendererAngularComp {

  params: ICellRendererParams & {
    additionalData: { icon: IconsEnum; colour: IconColourEnum; showMinutes?: boolean; tooltip?: string };
  };

  agInit(
    params: ICellRendererParams & {
      additionalData: { icon: IconsEnum; colour: IconColourEnum; showMinutes?: boolean; tooltip?: string };
    },
  ): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
